module.exports = __webpack_public_path__ + "img/134ne.97c63711.svg";